<template>
  <ProductCarousel
    v-if="products.length > 0"
    :title="carouselTitle"
    :header-link="{
      text: 'Shop all',
      link: '/collections/all',
    }"
    :products="products"
    :flat-lays="flatLays"
  />
</template>

<script>
import ProductCarousel from "@/components/ProductCarouselV2.vue";
import featuredCollectionQuery from "@/graphql/queries/FeaturedCollection.gql";
import productIdQuery from "@/graphql/queries/ProductId.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { PER_PAGE } from "@/helpers/pagination";

export default {
  name: "FeaturedProductsCarousel",
  components: {
    ProductCarousel,
  },
  props: {
    collectionHandle: {
      type: String,
      default: null,
    },
    flatLays: {
      type: Boolean,
      default: false,
    },
    productIds: {
      type: Array,
      default: null,
    },
    nostoPlacement: {
      type: String,
      default: null,
    },
    carouselTitle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      products: [],
    };
  },
  created() {
    this.getProducts();
  },
  methods: {
    async getProducts() {
      const promises = [];

      if (!this.productIds) {
        return;
      }

      this.productIds.forEach((product) => {
        promises.push(
          this.$apollo.query({
            query: productIdQuery,
            variables: {
              productId: "gid://shopify/Product/" + product.product_id,
            },
          })
        );
      });

      Promise.all(promises).then((values) => {
        values.map((value) => {
          const product = this.productWithReferralPlacement(value.data.product);
          this.products.push(product);
        });
      });
    },
    productWithReferralPlacement(product) {
      if (!this.nostoPlacement) {
        return product;
      }

      const newOnlineStoreUrl = new URL(product.onlineStoreUrl);
      newOnlineStoreUrl.searchParams.set("ref-placement", this.nostoPlacement);

      return {
        ...product,
        onlineStoreUrl: newOnlineStoreUrl,
      };
    },
  },
  apollo: {
    products: {
      query: featuredCollectionQuery,
      skip() {
        return !this.collectionHandle;
      },
      variables() {
        return {
          collection: this.collectionHandle,
          first: PER_PAGE,
        };
      },
      update({ collection }) {
        return unwrapNodes(collection.products?.edges);
      },
    },
  },
};
</script>
